import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Studio from './pages/Studio';
import Work from './pages/Work';
import Contact from './pages/Contact';
import Accelerator from './pages/Accelerator';
import Shop from './pages/Shop';
import Product from './pages/Product';
import Cart from './pages/Cart';
import Project from './pages/Project';
import Cult from './pages/Cult';
import CultPost from './pages/CultPost';
import Partners from './pages/Partners';
import NewProject from './pages/NewProject';
import LocationService from './pages/LocationService';
// Service pages
import UxDesign from './pages/studio/services/UxDesign';
import UiDesign from './pages/studio/services/UiDesign';
import WebDesign from './pages/studio/services/WebDesign';
import WebDevelopment from './pages/studio/services/WebDevelopment';
import ProductDevelopment from './pages/studio/services/ProductDevelopment';
import BrandIdentity from './pages/studio/services/BrandIdentity';
import MvpDevelopment from './pages/studio/services/MvpDevelopment';
import FractionalDesignServices from './pages/studio/services/FractionalDesignServices';
import IdeaAccelerator from './pages/studio/services/IdeaAccelerator';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="studio" element={<Studio />} />
          <Route path="studio/services/ux-design" element={<UxDesign />} />
          <Route path="studio/services/ui-design" element={<UiDesign />} />
          <Route path="studio/services/web-design" element={<WebDesign />} />
          <Route path="studio/services/web-development" element={<WebDevelopment />} />
          <Route path="studio/services/product-development" element={<ProductDevelopment />} />
          <Route path="studio/services/brand-identity" element={<BrandIdentity />} />
          <Route path="studio/services/mvp-development" element={<MvpDevelopment />} />
          <Route path="studio/services/fractional-design-services" element={<FractionalDesignServices />} />
          <Route path="studio/services/idea-accelerator" element={<IdeaAccelerator />} />
          <Route path="work" element={<Work />} />
          <Route path="shop" element={<Shop />} />
          <Route path="shop/:slug" element={<Product />} />
          <Route path="cart" element={<Cart />} />
          <Route path="projects/:slug" element={<Project />} />
          <Route path="cult" element={<Cult />} />
          <Route path="cult/:slug" element={<CultPost />} />
          <Route path="partners" element={<Partners />} />
          <Route path="new-project" element={<NewProject />} />
          <Route path="contact" element={<Contact />} />
          <Route path="accelerator" element={<Accelerator />} />
          <Route path="locations/:serviceSlug/:citySlug" element={<LocationService />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
